import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ValueSection } from '../components/ValueSection';
import { WhoThisIsFor } from '../components/WhoThisIsFor';
import { AboutSection } from '../components/AboutSection';
import { PricingSection } from '../components/PricingSection';
import { IntakeForm } from '../components/IntakeForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-215">
      <main data-id="element-216">
        <HeroSection data-id="element-217" />
        <ValueSection data-id="element-218" />
        <WhoThisIsFor data-id="element-219" />
        <AboutSection data-id="element-220" />
        <PricingSection data-id="element-221" />
        <IntakeForm data-id="element-222" />
      </main>
      <Footer data-id="element-223" />
    </div>;
}